import { useTracking } from '@change-corgi/core-react/tracking';

import { useGuideLinks } from 'src/app/shared/hooks/useGuideLinks';

type Result = ModelHookResult<
	{
		guideArticlesAndLinks: ReadonlyArray<{
			title: string;
			guideLink: string;
		}>;
	},
	{ trackGuideLinkClick: (url: string) => void }
>;

export function useGuidesSection(): Result {
	const guideArticlesAndLinks = useGuideLinks() ?? [];
	const track = useTracking();

	return {
		data: {
			guideArticlesAndLinks,
		},
		actions: {
			trackGuideLinkClick: (url: string) => {
				void track('impact_story_page_guide_link_click', { url });
			},
		},
	};
}
